import React from 'react'
import './App.css'

export default function App() {
  return (
    <div className="background">
      <div className="container">

        <h1 className="heading">Login Form</h1>

        <input
          type="text"
          placeholder="ENTER YOUR EMAIL :"
          className="firstinput"
        />

        <input
          type="password"
          placeholder="ENTER YOUR PASSWORD :"
          className="secondinput"
        />

        <button className="button">Login</button>

        <p className="para1">OR</p>
        <p className="para">already have an account</p>

      </div>
    </div>
  )
}
